import { GetRegion } from '../../../constants';

export const getAnonymousQueryParams = (episodeInfo, addToFavorite = false) => {
  const queryParams = {
    title_uri: episodeInfo?.title_uri || episodeInfo?.titleUri,
    group_id: episodeInfo?.id || episodeInfo?.group_id,
    anonymousUserComeFromPlayer: true,
    addFavorite: addToFavorite,
    urlVcard: `/${GetRegion()}/vcard/homeuser/${episodeInfo?.title_uri || episodeInfo?.titleUri}/${
      episodeInfo?.id || episodeInfo?.group_id
    }`,
  };
  return { queryParams };
};
